import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';

import './About.scss';

import Body from '../DetailPage/Body';

class About extends Component {

    static contextTypes = {
        router: PropTypes.object.isRequired
    };

    render() {
        const {body} = this.props.about;

        const className = classNames({
            "About": true,
            "About--open":  this.props.open
        });

        const classNameBurger = classNames({
            "Navigation__burger": true,
            "Navigation__burger--x":  true
        });

        return (
            <div className={className}>
                <div className="About__close">
                    <div className={classNameBurger} onClick={() => this.context.router.push(`/${this.props.language}`)}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>

                <div className="About__inner">
                    <Body body={body} />
                </div>
            </div>
        );
    }

}

function mapStateToProps({about, timeline}) {
    return {
        about,
        language: timeline.language
    }
}

export default connect(mapStateToProps, null)(About);



// WEBPACK FOOTER //
// ./src/components/About/index.js